import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

const hotKeywords = ['数据分析', '音乐节', '家电优惠', '在线问诊', '周边露营', '面试辅导'];

export default function HeroSection() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState('');

  const goSearch = (q: string) => {
    const trimmed = q.trim();
    navigate(trimmed ? `/search?q=${encodeURIComponent(trimmed)}` : '/search');
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    goSearch(keyword);
  };

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20calm%20deep%20blue%20gradient%20background%20with%20soft%20flowing%20geometric%20shapes%20and%20subtle%20light%20rays%2C%20minimal%20modern%20tech%20atmosphere%2C%20elegant%20professional%20portal%20design&width=1600&height=760&seq=online-hero-bg&orientation=landscape"
          alt="在线服务平台背景"
          title="在线 - 多元化在线服务平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/80 to-primary-900/55"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-14 md:py-24">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-50 text-xs md:text-sm mb-5">
            <i className="ri-shining-2-line text-accent-400"></i>
            教育 · 娱乐 · 购物 · 生活 · 科技 全品类聚合
          </span>
          <h1 className="text-3xl md:text-5xl font-bold leading-tight text-background-50">
            一站发现优质在线服务
            <br />
            <span className="text-accent-400">多元资源，快速查找</span>
          </h1>
          <p className="mt-5 text-base md:text-lg text-primary-100 max-w-2xl leading-relaxed">
            在线聚合教育学习、娱乐休闲、购物优惠等各类服务信息，支持分类浏览、精准筛选与详情查看，帮你高效找到所需资源。
          </p>

          <form onSubmit={handleSubmit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-2xl">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索课程、活动、优惠、服务…"
                className="w-full pl-12 pr-4 py-3.5 text-sm md:text-base rounded-md bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-accent-400"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm md:text-base rounded-md bg-accent-500 text-background-50 font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-search-2-line"></i>
              立即搜索
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs text-primary-200">热门搜索：</span>
            {hotKeywords.map((kw) => (
              <button
                key={kw}
                type="button"
                onClick={() => goSearch(kw)}
                className="px-3 py-1 text-xs rounded-full bg-background-50/10 text-background-50 hover:bg-background-50/20 transition-colors cursor-pointer"
              >
                {kw}
              </button>
            ))}
          </div>

          <div className="mt-10 flex flex-wrap gap-x-10 gap-y-4">
            {[
              { num: '8', label: '服务大类' },
              { num: '24+', label: '精选内容' },
              { num: '100%', label: '分类直达' },
            ].map((item) => (
              <div key={item.label}>
                <div className="text-2xl md:text-3xl font-bold text-background-50">{item.num}</div>
                <div className="text-xs md:text-sm text-primary-200 mt-0.5">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}